export default {"src":"/_next/static/media/retrieval_qa.69aad375.svg","height":1049,"width":1639,"blurWidth":0,"blurHeight":0};